document.querySelectorAll('[data-shorten="true"]').forEach(element => {
  if (element.scrollHeight > 300) {
      const chevron = document.createElement('div');
      chevron.classList.add('shortened-content-chevron');
      chevron.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none">
              <path d="M15.713 12L9.70202 5.99L8.28802 7.404L12.888 12.004L8.28802 16.597L9.70202 18.011L15.713 12Z" fill="#270D5B"/>
          </svg>
      `;

      element.style.maxHeight = '300px';
      element.style.overflow = 'hidden';
      element.style.position = 'relative';
      if (!element.querySelector('.shortened-content-chevron')) {
          element.appendChild(chevron);
      }

      chevron.addEventListener('click', () => {
          if (element.style.maxHeight === '300px') {
              element.style.maxHeight = `${element.scrollHeight}px`;
              chevron.style.transform = 'rotate(270deg)';
          } else {
              element.style.maxHeight = '300px';
              chevron.style.transform = 'rotate(90deg)';
          }
      });
  }
});
